import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useStripe, useElements} from '@stripe/react-stripe-js';
import {fetchError} from '../Store/Actions';
import {FETCH_START} from '../Constant/ActionTypes';

// Description: This hook is used to handle submit the stripe payment
// use this hook in the conponent wrapper with Elements component from stripe

const useStripeSubmit = (
  paymentFailedUrl,
  paymentSuccessUrl,
  dispatchSuccess,
  id,
  resetSecret,
  skipNavigateFromHook = false,
) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();

  const submitPayment = async () => {
    if (!stripe || !elements) return;
    dispatch({type: FETCH_START});
    try {
      const result = await stripe.confirmPayment({
        elements,
        redirect: 'if_required',
      });

      const pi = result?.paymentIntent;
      const pm = pi?.payment_method;
      const pmType =
        pm && typeof pm === 'object' && 'type' in pm ? pm.type : null;
      const piStatus = pi?.status;
      // Include `processing` so async methods are not shown as "Payment Failed" before PI succeeds.
      const confirmOk =
        result?.status === 'succeeded' ||
        piStatus === 'succeeded' ||
        piStatus === 'processing' ||
        piStatus === 'requires_action';
      if (confirmOk) {
        resetSecret();
        // US ACH: show "payment processing" until settled. Canadian PAD: same UX as card / regular registration.
        const isUsBankAch = pmType === 'us_bank_account';
        const isPad = pmType === 'acss_debit';
        const statusForUi =
          isUsBankAch && (piStatus === 'succeeded' || piStatus === 'processing')
            ? 'processing'
            : isPad && piStatus === 'processing'
            ? 'succeeded'
            : piStatus;
        const paymentIntentId = pi?.id;
        if (id !== undefined && id !== null) {
          dispatchSuccess(id, paymentIntentId, statusForUi);
        } else {
          dispatchSuccess(paymentIntentId, statusForUi);
        }
        // Event flow: action navigates with state after API. Jobs/Ads: we navigate here.
        if (!skipNavigateFromHook) {
          navigate(`${paymentSuccessUrl ? paymentSuccessUrl : '/'}`, {
            state: {status: statusForUi},
          });
        }
      } else {
        dispatch(
          fetchError(
            `${
              result?.error?.message
                ? result?.error?.message
                : 'Payment Failed, Please try again'
            }`,
          ),
        );
      }
    } catch (error) {
      dispatch(
        fetchError(
          `${
            error?.error?.message
              ? error?.error?.message
              : 'Payment Failed, Please try again'
          }`,
        ),
      );
    }
  };

  return submitPayment;
};

export default useStripeSubmit;
